import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Divider, Input, Modal, Radio, Space } from "antd";

import { Header, Nav, HamburgerMenu, BaseTable } from "./components";

import {
  loginUserCheck,
  logoutUser,
  productFetchByType,
  productUpdatePrice,
  productDeleteById,
} from "../redux/actions";

class AdminProductDetail extends Component {
  constructor() {
    super();
    this.state = {
      photo: "",
      brand_title: "",
      brand_id: "",
      selectType: "wall",
      toggleMenu: false,
      isModalOpen: false,
      isLoading: true,
      modalData: {},
      price: "",
      price2: "",
      price3: "",
      price4: "",
      columns: [
        {
          title: "Image",
          dataIndex: "img",
          key: "img",
          render: (text) => (
            <img
              src={text}
              style={{ height: "30px", maxWidth: "100px" }}
              alt="product"
            />
          ),
        },
        {
          title: "Model",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "Price (1)",
          dataIndex: "price",
          key: "price",
        },
        {
          title: "Type",
          dataIndex: "type",
          key: "type",
          render: (text) => {
            let type = "";
            if (text === "wall") type = "แอร์ผนัง";
            else if (text === "hang") type = "แอร์แขวน";
            else if (text === "four") type = "แอร์สี่ทิศทาง";
            else if (text === "one_way") type = "แอร์หนึ่งทิศทาง";
            else type = "แอร์เปลือย";
            return type;
          },
        },
        {
          title: "Inventory",
          dataIndex: "inventory",
          key: "inventory",
        },
        {
          title: "BTU",
          dataIndex: "btu",
          key: "btu",
        },
        {
          title: "Created Date",
          dataIndex: "prod_id",
          key: "prod_id",
          render: (text) => {
            const d = new Date(Number(text));
            const date =
              d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
            return date;
          },
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
            <Space size="middle" className="table-action">
              <Button
                type="primary"
                className="btn-edit"
                onClick={() => {
                  this.setState({
                    isModalOpen: true,
                    modalData: record,
                    price: record.price,
                    price2: record.price2,
                    price3: record.price3,
                    price4: record.price4,
                  });
                }}
              >
                ราคา
              </Button>
              <Divider type="vertical" />
              <Button
                type="primary"
                className="btn-edit"
                onClick={() =>
                  (window.location = `/admin/editproduct?id=${record.id}`)
                }
              >
                แก้ไข
              </Button>
              <Divider type="vertical" />
              <Button
                type="primary"
                danger
                onClick={() =>
                  this._onDeleteItem(record.id, record.img, record.type)
                }
              >
                ลบ
              </Button>
            </Space>
          ),
        },
      ],
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    const params = this.getParams();
    this.setState({
      brand_id: params.id,
      brand_title: params.title,
      selectType: params.type,
    });
  }

  componentDidMount() {
    this._handleSelectType(this.state.selectType);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.products) {
      this.setState({ isLoading: false });
    }
  }

  getParams() {
    const searchParams = new URLSearchParams(this.props.location.search);
    return {
      id: searchParams.get("id") || "",
      title: searchParams.get("title") || "",
      type: searchParams.get("type") || "wall",
    };
  }

  _handleSelectType(type) {
    this.props.productFetchByType(this.state.brand_title, type);
    this.setState({ selectType: type });
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  _onSubmitPrice() {
    const data = {
      price: this.state.price,
      price2: this.state.price2,
      price3: this.state.price3,
      price4: this.state.price4,
    };
    this.props.productUpdatePrice(this.state.modalData.id, data);
    this.setState({ isModalOpen: false });
  }

  _onDeleteItem(id, img, type) {
    if (window.confirm("Are you sure you want to delete this item?")) {
      let file = decodeURIComponent(img.substring(70, 97));
      const data = {
        brand_id: this.state.brand_id,
        brand_title: this.state.brand_title,
        type: "type_" + type,
        type2: type,
      };
      this.props.productDeleteById(id, file, data);
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-productdetail">
          <Nav active="product" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>
                  สินค้า :{" "}
                  <span className="brandname">{this.state.brand_title}</span>
                </h2>

                <Radio.Group
                  disabled={this.state.isLoading}
                  defaultValue={this.state.selectType}
                  buttonStyle="solid"
                  onChange={(event) =>
                    this._handleSelectType(event.target.value)
                  }
                >
                  <Radio.Button value="wall">แอร์ผนัง</Radio.Button>
                  <Radio.Button value="hang">แอร์แขวน</Radio.Button>
                  <Radio.Button value="four">แอร์สี่ทิศทาง</Radio.Button>
                  <Radio.Button value="concealed">แอรเ์ปลือย</Radio.Button>
                  <Radio.Button value="stand">แอร์ตู้ตั้ง</Radio.Button>
                  <Radio.Button value="one_way">หนึ่งทิศทาง</Radio.Button>
                </Radio.Group>

                <div className="btn-addproduct">
                  <Link
                    to={{
                      pathname: "/admin/addproduct",
                      search: `?id=${this.state.brand_id}&title=${this.state.brand_title}&type=${this.state.selectType}`,
                    }}
                    className="add-product"
                  >
                    เพิ่มสินค้า
                  </Link>
                </div>
              </div>
              <div className="info">
                <BaseTable
                  columns={this.state.columns}
                  datas={this.props.products ? this.props.products : []}
                  loading={this.state.isLoading}
                />
              </div>
              <Modal
                title="แก้ไขราคา"
                cancelText="ยกเลิก"
                okText="บันทึก"
                open={this.state.isModalOpen}
                onOk={() => this._onSubmitPrice()}
                onCancel={() => this.setState({ isModalOpen: false })}
              >
                <h3>{this.state.modalData.title}</h3>
                <div
                  className="price"
                  style={{
                    display: "flex",
                    margin: "20px 0",
                    marginRight: "20px",
                  }}
                >
                  <p style={{ width: "130px", margin: "auto" }}>
                    ราคา (Rank 1):
                  </p>
                  <Input
                    name="price"
                    value={this.state.price}
                    onChange={(event) => this._onHandleChange(event)}
                  />
                </div>
                <div
                  className="price"
                  style={{
                    display: "flex",
                    margin: "20px 0",
                    marginRight: "20px",
                  }}
                >
                  <p style={{ width: "130px", margin: "auto" }}>
                    ราคา (Rank 2):
                  </p>
                  <Input
                    name="price2"
                    value={this.state.price2}
                    onChange={(event) => this._onHandleChange(event)}
                  />
                </div>
                <div
                  className="price"
                  style={{
                    display: "flex",
                    margin: "20px 0",
                    marginRight: "20px",
                  }}
                >
                  <p style={{ width: "130px", margin: "auto" }}>
                    ราคา (Rank 3):
                  </p>
                  <Input
                    name="price3"
                    value={this.state.price3}
                    onChange={(event) => this._onHandleChange(event)}
                  />
                </div>
                <div
                  className="price"
                  style={{
                    display: "flex",
                    margin: "20px 0",
                    marginRight: "20px",
                  }}
                >
                  <p style={{ width: "130px", margin: "auto" }}>
                    ราคา (Rank 4):
                  </p>
                  <Input
                    name="price4"
                    value={this.state.price4}
                    onChange={(event) => this._onHandleChange(event)}
                  />
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, product }) => {
  return {
    user: auth.user,
    products: product.products,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  productFetchByType,
  productUpdatePrice,
  productDeleteById,
})(AdminProductDetail);
